import { render, staticRenderFns } from "./warnings-dialog.vue?vue&type=template&id=02035971"
import script from "./warnings-dialog.vue?vue&type=script&lang=js"
export * from "./warnings-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports